import { AppRootScope } from '../typings/AppRootScope';

export class DialogController implements angular.IController {
    public static $inject = [
        '$rootScope',
        '$scope',
        '$mdDialog',
        'data'
    ];

    constructor(
        private $rootScope: AppRootScope,
        private $scope: any,
        private $mdDialog: angular.material.IDialogService,
        private data: any
    ) {
    }

    public $onInit() {
        this.$scope.data = this.data;
        this.$scope.theme = this.$rootScope.currentTheme.name;
    }
}
